import { useAppStore } from '@/stores/app';
import { Org } from '@/types';
import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useShallow } from 'zustand/react/shallow';

const useSwitchOrganization = (data: Org) => {
  const { t } = useTranslation('orgs');
  const navigate = useNavigate();

  const { selectedOrganization, setSelectedOrganization, setSelectedOrgId } = useAppStore(
    useShallow(state => ({
      selectedOrganization: state.selectedOrganization,
      setSelectedOrganization: state.setSelectedOrganization,
      setSelectedOrgId: state.setSelectedOrgId,
    })),
  );

  const isSelected = selectedOrganization?.id === data.id;

  const handleChange = useCallback(
    (goToStudies: boolean = false) => {
      setSelectedOrganization(data);
      setSelectedOrgId(data.id);
      toast.success(t('org_switched_success', { name: data.name }));

      if (goToStudies) {
        navigate({ to: '/studies' });
      }
    },
    [data, navigate, setSelectedOrganization, setSelectedOrgId, t],
  );

  return {
    handleChange,
    isSelected,
  };
};

export default useSwitchOrganization;
